/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Empty"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let taskBoardsListIconOnlyValueData = fromData.useDataValue({ viewPath,
context: 'task_boards_list',
path: 'iconOnly',
})
let taskBoardsListTypeValueData = fromData.useDataValue({ viewPath,
context: 'task_boards_list',
path: 'type',
})
let constantData = 'my-boards'
let aggregateData = fromHelpers.getView(taskBoardsListIconOnlyValueData, taskBoardsListTypeValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}